import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ENewbuildingBookingActionTypes {
  CloseConfirm = 'newbuildingBooking/closeConfirm',
  CloseSuccess = 'newbuildingBooking/closeSuccess',
  OpenConfirm = 'newbuildingBooking/openConfirm',
  SetBookingFailure = 'newbuildingBooking/setBookingFailure',
  SetBookingLoading = 'newbuildingBooking/setBookingLoading',
  SetBookingSuccess = 'newbuildingBooking/setBookingSuccess',
}

export type TCloseNewbuildingBookingConfirm = ITypedReduxAction<ENewbuildingBookingActionTypes.CloseConfirm, void>;
export type TCloseNewbuildingBookingSuccess = ITypedReduxAction<ENewbuildingBookingActionTypes.CloseSuccess, void>;
export type TOpenNewbuildingBookingConfirm = ITypedReduxAction<ENewbuildingBookingActionTypes.OpenConfirm, void>;
export type TSetNewbuildingBookingFailure = ITypedReduxAction<ENewbuildingBookingActionTypes.SetBookingFailure, void>;
export type TSetNewbuildingBookingLoading = ITypedReduxAction<ENewbuildingBookingActionTypes.SetBookingLoading, void>;
export type TSetNewbuildingBookingSuccess = ITypedReduxAction<ENewbuildingBookingActionTypes.SetBookingSuccess, string>;

export const openNewbuildingBookingConfirm = actionGenerator<ENewbuildingBookingActionTypes.OpenConfirm>(
  ENewbuildingBookingActionTypes.OpenConfirm,
);

export const closeNewbuildingBookingConfirm = actionGenerator<ENewbuildingBookingActionTypes.CloseConfirm>(
  ENewbuildingBookingActionTypes.CloseConfirm,
);

export const closeNewbuildingBookingSuccess = actionGenerator<ENewbuildingBookingActionTypes.CloseSuccess>(
  ENewbuildingBookingActionTypes.CloseSuccess,
);

export const setNewbuildingBookingFailure = actionGenerator<ENewbuildingBookingActionTypes.SetBookingFailure>(
  ENewbuildingBookingActionTypes.SetBookingFailure,
);

export const setNewbuildingBookingLoading = actionGenerator<ENewbuildingBookingActionTypes.SetBookingLoading>(
  ENewbuildingBookingActionTypes.SetBookingLoading,
);

export const setNewbuildingBookingSuccess = actionGenerator<ENewbuildingBookingActionTypes.SetBookingSuccess, string>(
  ENewbuildingBookingActionTypes.SetBookingSuccess,
);

export type TNewbuildingBookingActions =
  | TCloseNewbuildingBookingConfirm
  | TCloseNewbuildingBookingSuccess
  | TOpenNewbuildingBookingConfirm
  | TSetNewbuildingBookingFailure
  | TSetNewbuildingBookingLoading
  | TSetNewbuildingBookingSuccess;
